// TODO: https://gitlab.com/mates-pay/app/new_reco/reco_for_teacher/-/issues/2312
export type LocalStorageInterface = {
  getItem: <T extends string>(key: LocalStorageKey) => T | null;

  setItem: (key: LocalStorageKey, value: string) => void;

  removeItem: (key: LocalStorageKey) => void;
};

export enum LocalStorageKey {
  currentClassroomId = 'currentClassroomId',
  komaViewState = 'komaViewState',
  bulkUpdateGuidanceKomasApplyEndDate = 'bulkUpdateGuidanceKomasApplyEndDate',

  /**
   * - 作成、更新: selectedFilterOption という ref を watch
   *   - src/domain/useCases/reco/guidance/koma/guidanceSchedule/index.ts
   * - リセット: 教室切り替え時に担任情報(homeroomManagementUserId)を null に設定
   *   - src/domain/fragments/user/account/ClassroomChangeDialog.vue
   */
  guidanceScheduleFilterOption = 'guidanceScheduleFilterOption',
  guidanceJukuTestWithSummariesFilterOption = 'guidanceJukuTestWithSummariesFilterOption',
  studentsFilterOption = 'studentsFilterOption'
}
